












import { Component, Vue, Watch } from 'vue-property-decorator'
import Navbar from './components/Navbar.vue'
import PageFooter from './components/PageFooter.vue'

import { setQuery, getQuery, getTheme } from './utils'

@Component({
  components: {
    Navbar,
    PageFooter
  }
})
export default class App extends Vue {

  @Watch('$route')
  onRouteChanged() {
    (this.$refs.content as HTMLDivElement).scrollTop = 0
  }

  created() {
    const theme = getTheme()
    if (document && document.documentElement) {
      document.documentElement.classList.add(`theme-${theme}`)
    }
  }

  mounted() {
    document.body.onclick = e => {
      if (e.target && e.target instanceof HTMLAnchorElement && e.target.classList.contains('header-anchor')) {
        e.preventDefault()
        const hash = decodeURIComponent(e.target.href.split('#')[1])
        const query = getQuery()
        query.hash = hash
        setQuery(query)
      }
    }
  }
}
